import URLQueryBuilder from 'url-query-builder';

import './c-tabs.scss';
import template from './tabs.vhtml';

export default {
	template,
	props: {
		tabs: {
			type: Array,
			required: true,
		},
		selected: {
			type: Number,
			required: true,
		},
		capitalize: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			urlParam: getUrlVars()['tab'],
		};
	},
	watch: {
		selected() {
			this.updateUrl( this.tabs[ this.selected ].name );
		},
	},
	methods: {
		selectTab( index ) {
			this.$emit( 'select-tab', index );
		},
		updateUrl( newTab ) {
			const urlParams = Object.assign({}, { tab: newTab });

			const q = new URLQueryBuilder( document.location.href, urlParams );
			window.history.replaceState( null, null, q.getUrl() );
		},
	},
	created() {
		this.urlParam = getUrlVars()['tab'];
		if ( typeof this.urlParam !== 'undefined' ) {
			const selectedTab = findWithAttr( this.tabs, 'name', decodeURI( this.urlParam ) );
			if ( selectedTab !== -1 ) {
				this.selectTab( selectedTab );
			} else {
				this.updateUrl( this.tabs[ this.selected ].name );
			}
		}
	},
};

// Read a page's GET URL variables and return them as an associative array.
function getUrlVars() {
	let vars = [], hash;
	const hashes = window.location.search.slice( window.location.search.indexOf( '?' ) + 1 ).split( '&' );
	for ( let i = 0; i < hashes.length; i++ ) {
		hash = hashes[i].split( '=' );
		vars.push( hash[0]);
		vars[hash[0]] = hash[1];
	}
	return vars;
}

function findWithAttr( array, attr, value ) {
	for ( let i = 0; i < array.length; i += 1 ) {
		if ( array[i][attr] === value ) {
			return i;
		}
	}
	return -1;
}



// WEBPACK FOOTER //
// ./assets/_js/components/tabs/tabs.js